import bidding from './bidding';
import binForm from './bin-form';
import cartCheckout from './cart-checkout';
import cartOverview from './cart-overview';
import cartPaypalPayment from './cart-paypal-payment';
import categoryList from './category-list';
import checkoutSelectPayment from './checkout-select-payment';
import checkout2 from './checkout2';
import klarnaPin from './klarna-pin';
import klarnaSignup from './klarna-signup';
import logger from 'logger';

const loadModules = {
    'basic': System.import('./basic'),
    'bidding': bidding,
    'bin-form': binForm,
    'cart-checkout': cartCheckout,
    'cart-overview': cartOverview,
    'cart-paypal-payment': cartPaypalPayment,
    'category-list': categoryList,
    'category': System.import('./category'),
    'checkout-select-payment': checkoutSelectPayment,
    'checkout2': checkout2,
    'custom-results': System.import('./custom-results'),
    'detailed-search': System.import('./detailed-search'),
    'klarna-pin': klarnaPin,
    'klarna-signup': klarnaSignup,
    'member-search': System.import('./member-search'),
    'messages': System.import('./messages'),
    'profile': System.import('./profile'),
    'search-results': System.import('./search-results'),
    'start-page': System.import('./start-page'),
    'view-item': System.import('./view-item')
};

export default initData => {
    let module = '';
    const mod = initData.module.split('/');
    console.log('Module ====== : ' + mod[4]);
    module = loadModules[mod[4]];

    try {
        if (typeof module === 'function') {
            module(initData);
        } else {
            module
                .then(module => module.default(initData))
                .catch(error => {
                    logger(error)
                });
        }
    } catch (e) {
        logger(e);
    };
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/load-modules.js